import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SolutionsStorefrontExplainer() {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "start",
    children: [/*#__PURE__*/_jsx(View, {
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "200",
      borderBlockEndColor: "fill-accent-blue-default",
      paddingBlockEnd: "200",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.solutionsStorefrontExplainer.title"
        })
      })
    }), /*#__PURE__*/_jsxs(Grid, {
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: {
          sm: 12,
          md: 4
        },
        display: "flex",
        flexDirection: "column",
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "start",
          gap: "300",
          children: [/*#__PURE__*/_jsx(Badge, {
            use: "thunderdome",
            children: "1"
          }), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            gap: "400",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h7",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplaceStorefront.solutionsStorefrontExplainer.step.one.title"
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.solutionsStorefrontExplainer.step.one.description"
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          sm: 12,
          md: 4
        },
        display: "flex",
        flexDirection: "column",
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "start",
          gap: "300",
          children: [/*#__PURE__*/_jsx(Badge, {
            use: "thunderdome",
            children: "2"
          }), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            gap: "400",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h7",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplaceStorefront.solutionsStorefrontExplainer.step.two.title"
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.solutionsStorefrontExplainer.step.two.description"
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          sm: 12,
          md: 4
        },
        display: "flex",
        flexDirection: "column",
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "start",
          gap: "300",
          children: [/*#__PURE__*/_jsx(Badge, {
            use: "thunderdome",
            children: "3"
          }), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            gap: "400",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h7",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplaceStorefront.solutionsStorefrontExplainer.step.three.title"
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.solutionsStorefrontExplainer.step.three.description"
            })]
          })]
        })
      })]
    })]
  });
}